export enum CameraType {
  Perspective = 'PerspectiveCamera',
  Orthographic = 'OrthographicCamera'
}
